import { DefaultTheme, withTheme } from 'styled-components';
import { Row } from 'antd';

import PropertyCard from './propertyCard';

type Props = {
  query: string;
  section: string;
  cardsCount: number;
  verticalMode: boolean;
  theme: DefaultTheme;
};

const CardsDisplay: React.FC<Props> = ({
  query,
  section,
  cardsCount,
  verticalMode,
  theme,
}) => (
  <Row gutter={[32, 32]}>
    {[...Array(cardsCount).keys()].map((index) => (
      <PropertyCard
        key={index}
        query={query}
        section={section}
        index={index}
        verticalMode={verticalMode}
        theme={theme}
      />
    ))}
  </Row>
);

export default withTheme(CardsDisplay);
